<template>
	<section class="form-section" :class="[`form-section--${tone}`, { 'form-section--tight': tight }]">
		<header class="form-section__head">
			<span class="form-section__icon"><v-icon>{{ icon }}</v-icon></span>
			<div class="form-section__heading">
				<small v-if="eyebrow">{{ eyebrow }}</small>
				<h3>{{ title }}</h3>
				<p v-if="description">{{ description }}</p>
			</div>
			<span v-if="badge" class="form-section__badge">{{ badge }}</span>
			<slot name="aside"></slot>
		</header>
		<div class="form-section__body">
			<slot></slot>
		</div>
	</section>
</template>

<script>
export default {
	name: 'form-section',
	props: {
		badge: {
			default: '',
			type: String,
		},
		description: {
			default: '',
			type: String,
		},
		eyebrow: {
			default: '',
			type: String,
		},
		icon: {
			default: 'tune',
			type: String,
		},
		tight: {
			default: false,
			type: Boolean,
		},
		title: {
			required: true,
			type: String,
		},
		tone: {
			default: 'brand',
			type: String,
		},
	},
};
</script>

<style lang="scss">
/*
 * Bloque de campos con encabezado. Como tarjeta cuando vive sobre un fondo
 * suave (cuerpo de un modal) y como sección con separador cuando está dentro
 * de `.form-sidebar`, que ya aporta su propia tarjeta blanca.
 */
.form-section {
	background: #fff;
	border: 1px solid #e4ebf2;
	border-radius: 12px;
	box-shadow: 0 4px 16px rgba(31, 55, 78, .05);
	margin-bottom: 14px;
	padding: 16px 18px;

	&:last-child { margin-bottom: 0; }
}

.form-section__head {
	align-items: flex-start;
	display: flex;
	gap: 11px;
	margin-bottom: 15px;

	.form-section__heading { flex: 1 1 auto; min-width: 0; }

	small {
		color: #8497a8;
		display: block;
		font-size: 9px;
		font-weight: 700;
		letter-spacing: .12em;
		text-transform: uppercase;
	}

	h3 {
		color: #263f56;
		font-family: map-get($fonts, open-semibold);
		font-size: 15px;
		font-weight: 600;
		line-height: 1.25;
		margin: 1px 0 0;
	}

	p {
		color: #8495a5;
		font-size: 11px;
		line-height: 1.35;
		margin: 3px 0 0;
	}
}

.form-section__icon {
	align-items: center;
	background: #eaf3ef;
	border-radius: 10px;
	display: flex;
	flex: 0 0 auto;
	height: 34px;
	justify-content: center;
	width: 34px;

	.icon { color: #1a4338; font-size: 18px; }
}

.form-section__badge {
	background: #eef3f8;
	border: 1px solid #dbe4ed;
	border-radius: 10px;
	color: #53697d;
	flex: 0 0 auto;
	font-size: 10px;
	font-weight: 700;
	letter-spacing: .04em;
	padding: 3px 8px;
	text-transform: uppercase;
}

.form-section--info {
	.form-section__icon { background: #eaf2fb; .icon { color: #176fc1; } }
}

.form-section--warning {
	.form-section__icon { background: #fdf1dc; .icon { color: #a6711a; } }
}

.form-section--tight .form-section__head { margin-bottom: 10px; }

/* Dentro del formulario de página la tarjeta la pone `.form-sidebar`. */
.form-sidebar .form-section {
	background: transparent;
	border: 0;
	border-radius: 0;
	box-shadow: none;
	margin-bottom: 0;
	padding: 0;

	& + .form-section {
		border-top: 1px solid #edf1f6;
		margin-top: 20px;
		padding-top: 20px;
	}
}

@media (max-width: 700px) {
	.form-section { padding: 13px 14px; }
	.form-section__head { gap: 9px; }
	.form-section__icon { height: 30px; width: 30px; .icon { font-size: 16px; } }
	.form-section__head h3 { font-size: 14px; }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/form-section.vue